/* ═══════════════════════════════════════════════════
   CLEAN PRODUCTS + REVIEWS — cps-script.js
   v5 — FCP/LCP Optimized · Animations deferred to window load
   Place in: /assets/cps-script.js
═══════════════════════════════════════════════════ */

(function () {
  'use strict';

  var MOB_BP = 639;
  function isMobile() { return window.innerWidth <= MOB_BP; }

  /* ── Unlock animations after full page load (FCP safe) ── */
  function unlockAnimations() {
    var sections = document.querySelectorAll('.cps-wrap');
    sections.forEach(function (s) { s.classList.add('cps-loaded'); });
  }

  if (document.readyState === 'complete') {
    unlockAnimations();
  } else {
    window.addEventListener('load', unlockAnimations);
  }

  /* ── Re-init JudgeMe ─────────────────────────── */
  function initJDGM() {
    if (window.jdgm && typeof window.jdgm.init === 'function') window.jdgm.init();
  }
  document.addEventListener('DOMContentLoaded', initJDGM);
  document.addEventListener('shopify:section:load', function () {
    initJDGM();
    unlockAnimations();
  });

  /* ── Lazy-load alt images (hover swap) ──────── */
  /* Only load img-alt when user hovers the card — saves bandwidth */
  document.addEventListener('mouseover', function (e) {
    var card = e.target.closest('.cps-card');
    if (!card) return;
    var alt = card.querySelector('.cps-img-alt');
    if (alt && !alt.dataset.loaded) {
      var realSrc = alt.src || alt.dataset.src;
      if (realSrc) {
        alt.src = realSrc;
        alt.dataset.loaded = '1';
        alt.classList.add('cps-img-loaded');
      }
    }
  }, { passive: true });

  /* ── IntersectionObserver: fade-in cards on scroll ── */
  /* Only runs for cards below the fold (index > 4) */
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('cps-img-loaded');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px 120px 0px', threshold: 0.1 });

    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.cps-card[data-index]').forEach(function (card) {
        var idx = parseInt(card.dataset.index, 10);
        if (idx > 4) observer.observe(card);
      });
    });
  }

  /* ── Add to Cart (delegated) ─────────────────── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cps-atc');
    if (!btn) return;
    e.preventDefault();

    var vid        = btn.dataset.variantId;
    var name       = btn.dataset.productName;
    var image      = btn.dataset.productImage;
    var priceCents = parseFloat(btn.dataset.productPrice) || 0;
    var price      = priceCents / 100;
    var origText   = btn.textContent.trim();

    btn.textContent   = 'Adding…';
    btn.disabled      = true;
    btn.style.opacity = '0.65';

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ id: vid, quantity: 1 })
    })
    .then(function () { return fetch('/cart.js'); })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var freeAt    = 300000;
      var subtotal  = cart.items_subtotal_price;
      var remaining = Math.max(0, freeAt - subtotal);
      var pct       = Math.min(100, (subtotal / freeAt) * 100);

      var modal = document.getElementById('cartModal');
      if (modal) {
        function $id(id) { return document.getElementById(id); }
        if ($id('modal-product-image'))  $id('modal-product-image').src         = image;
        if ($id('modal-product-name'))   $id('modal-product-name').textContent  = name;
        if ($id('modal-product-price'))  $id('modal-product-price').textContent =
          'Rs. ' + price.toLocaleString('en-PK');
        if ($id('cart-subtotal'))        $id('cart-subtotal').textContent =
          'Rs. ' + (subtotal / 100).toLocaleString('en-PK');
        if ($id('cart-total'))           $id('cart-total').textContent =
          'Rs. ' + (subtotal / 100).toLocaleString('en-PK');
        if ($id('progress-fill'))        $id('progress-fill').style.width = pct + '%';
        if ($id('shipping-message'))     $id('shipping-message').innerHTML =
          remaining <= 0
            ? '🎉 You\'ve unlocked FREE shipping!'
            : 'You\'re <strong>Rs. ' + (remaining / 100).toLocaleString('en-PK') +
              '</strong> away from FREE shipping 🎁';
        modal.style.display = 'flex';
        setTimeout(function () { modal.style.display = 'none'; }, 8000);
      }

      btn.textContent   = 'Added ✔';
      btn.disabled      = false;
      btn.style.opacity = '1';
      setTimeout(function () { btn.textContent = origText; }, 2500);

      var bubble = document.querySelector('.cart-count, .cart-count-bubble, [data-cart-count]');
      if (bubble) bubble.textContent = cart.item_count;

      document.dispatchEvent(new CustomEvent('cps:cart:updated', { detail: { cart: cart } }));
    })
    .catch(function (err) {
      console.error('[CPS] cart error:', err);
      btn.textContent   = origText;
      btn.disabled      = false;
      btn.style.opacity = '1';
      alert('Something went wrong. Please try again.');
    });
  });

  /* ── Show More / Less (delegated) ───────────── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cps-more-btn');
    if (!btn) return;

    var secId    = btn.dataset.section;
    var mobile   = isMobile();
    var initial  = mobile
      ? (parseInt(btn.dataset.mobInitial, 10) || 2)
      : (parseInt(btn.dataset.initial,    10) || 8);
    var moreText = btn.dataset.moreText || 'Show More';
    var lessText = btn.dataset.lessText || 'Show Less';
    var sec      = document.getElementById('cps-' + secId);
    if (!sec) return;

    var cards    = sec.querySelectorAll('.cps-card');
    var expanded = btn.classList.contains('expanded');
    var label    = btn.querySelector('.cps-more-label');

    if (!expanded) {
      cards.forEach(function (c) {
        c.classList.remove('cps-hidden');
        c.classList.remove('cps-mob-hidden');
      });
      btn.classList.add('expanded');
      if (label) label.textContent = lessText;
    } else {
      cards.forEach(function (c, i) {
        if (i >= initial) {
          mobile ? c.classList.add('cps-mob-hidden') : c.classList.add('cps-hidden');
        }
      });
      btn.classList.remove('expanded');
      if (label) label.textContent = moreText;
      sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  /* ── Show More button visibility on mobile ──── */
  document.addEventListener('DOMContentLoaded', function () {
    if (!isMobile()) return;
    document.querySelectorAll('.cps-more-btn').forEach(function (btn) {
      var mobInitial = parseInt(btn.dataset.mobInitial, 10) || 2;
      var sec = document.getElementById('cps-' + btn.dataset.section);
      if (!sec) return;
      var totalCards = sec.querySelectorAll('.cps-card').length;
      var wrap = btn.closest('.cps-more-wrap');
      if (wrap) wrap.style.display = totalCards > mobInitial ? '' : 'none';
    });
  });

})();